<template>
  <job-preview-content-outline
    title="問い合わせ"
    data-test="inquiry"
    v-on="$listeners"
  >
    <job-preview-content
      :comment-highlights="commentHighlights"
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      :text-counts="textCounts"
      v-on="$listeners"
    >
      <template #body>
        <p class="clearfix">
          <span
            data-test="company-name"
            v-html="`${companyName}<br>`"
          />
          <component
            :is="tag"
            v-if="url"
            :id="targetIdMap.selection.inquiry.url"
            :href="url"
            :class="{'text-underline':highlightMode}"
            target="_blank"
            rel="nofollow"
            data-test="url"
            v-text="url"
          /><br
            v-if="url"
            data-test="br-url"
          >
          <span
            v-if="zip"
            :id="targetIdMap.selection.inquiry.zip"
            data-test="zip"
            v-text="`〒 ${zip}`"
          />
          <span
            v-if="address"
            :id="targetIdMap.selection.inquiry.address"
            class="pega-pre-wrap"
            data-test="address"
            v-text="address"
          />
          <br
            v-if="zip || address"
            data-test="br-address"
          >
          <span
            v-if="person"
            :id="targetIdMap.selection.inquiry.person"
            data-test="person"
            v-html="`担当者 ／ ${person}<br>`"
          />
          <span
            v-if="tel"
            :id="targetIdMap.selection.inquiry.tel"
            data-test="tel"
            v-html="`Tel ／ ${tel}<br>`"
          />
          <span
            v-if="email"
            :id="targetIdMap.selection.inquiry.email"
            data-test="email"
            v-text="`E-mail ／ ${email}`"
          />
        </p>
      </template>
    </job-preview-content>
  </job-preview-content-outline>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewContentOutline from '@/components/atoms/JobPreviewContentOutline'
import JobPreviewContent from '@/components/atoms/JobPreviewContent'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  components: {
    JobPreviewContentOutline,
    JobPreviewContent
  },
  mixins: [jobPreviewCommon],
  props: {
    companyName: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    zip: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    person: {
      type: String,
      default: ''
    },
    tel: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    textCounts () {
      return [
        this.getTextCount('住所', this.address, this.targetIdMap.selection.inquiry.address),
        this.getTextCount('担当者', this.person, this.targetIdMap.selection.inquiry.person),
        this.getTextCount('TEL', this.tel, this.targetIdMap.selection.inquiry.tel),
        this.getTextCount('E-mail', this.email, this.targetIdMap.selection.inquiry.email)
      ]
    }
  }
}
</script>
